var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6993 32.6633C31.9716 32.6785 32.2414 32.7234 32.5039 32.7971C32.884 32.9037 33.2332 33.0616 33.5513 33.2603V21.199C33.5513 18.2703 31.3046 15.873 28.5586 15.873H9.23506C6.48912 15.873 4.24219 18.2697 4.24219 21.199V33.3959C4.6131 33.1324 5.0125 32.7996 5.49341 32.7972L31.6993 32.6633Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8992 0.933594C22.9555 0.933594 26.2437 4.22172 26.2437 8.27793C26.2437 12.3341 22.9554 15.6224 18.8992 15.6224C14.843 15.6224 11.5547 12.3341 11.5547 8.27793C11.5547 4.22172 14.843 0.933594 18.8992 0.933594Z",
    fill: "#BCBCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4113 41.0225C25.7466 39.4449 21.7172 39.6881 18.7186 43.0663C16.0472 40.3024 12.4341 39.3892 7.38281 40.8366V20.288C12.0589 19.6709 15.6042 20.4644 18.8971 24.2468C21.752 20.0921 26.0116 20.0853 30.4113 20.3378V41.0225Z",
    fill: "#727272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4875 26.3184C33.2411 26.3184 34.6625 28.1928 34.6625 30.5052C34.6625 32.818 33.2411 34.6924 31.4875 34.6924C29.734 34.6924 28.3125 32.818 28.3125 30.5052C28.3125 28.1929 29.734 26.3184 31.4875 26.3184Z",
    fill: "#BCBCBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50317 26.3184C8.25668 26.3184 9.67813 28.1928 9.67813 30.5052C9.67813 32.818 8.25668 34.6924 6.50317 34.6924C4.74958 34.6924 3.32812 32.818 3.32812 30.5052C3.32812 28.1929 4.74958 26.3184 6.50317 26.3184Z",
    fill: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 43.066H37.0346V39.2012H0.960938V43.066Z",
    fill: "#6A6A6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0315 43.066H19V39.2012H37.0315V43.066Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.dfe63c96779e7423cc73d37766188010.svg";
export { ForwardRef as ReactComponent };